import React from 'react';
import { Row, Col, Card, Typography, Skeleton } from 'antd';

const { Title } = Typography;

const CountCard = ({
	totalCountTitle,
	totalCountContent,
	totalSuccessCountTitle,
	totalSuccessCountContent,
	totalFailedCountTitle,
	totalFailedCountContent,
	totalPendingCountTitle,
	totalPendingCountContent,
	totalUnprocessedCountTitle,
	totalUnprocessedCountContent,
	loading,
}) => {
	return (
		<Row justify="space-between">
			<Col span={4}>
				<Card
					title={totalCountTitle.toUpperCase()}
					bordered={false}
					style={{ width: 250 }}
				>
					<Skeleton loading={loading}>
						<Title level={3}>{totalCountContent}</Title>
					</Skeleton>
				</Card>
			</Col>
			<Col span={4}>
				<Card
					title={totalSuccessCountTitle.toUpperCase()}
					bordered={false}
					style={{ width: 250 }}
				>
					<Skeleton loading={loading}>
						<Title level={3}>{totalSuccessCountContent}</Title>
					</Skeleton>
				</Card>
			</Col>
			<Col span={4}>
				<Card
					title={totalFailedCountTitle.toUpperCase()}
					bordered={false}
					style={{ width: 250 }}
				>
					<Skeleton loading={loading}>
						<Title level={3}>{totalFailedCountContent}</Title>
					</Skeleton>
				</Card>
			</Col>
			{totalPendingCountContent && (
				<Col span={4}>
					<Card
						title={totalPendingCountTitle.toUpperCase()}
						bordered={false}
						style={{ width: 250 }}
					>
						<Skeleton loading={loading}>
							<Title level={3}>{totalPendingCountContent}</Title>
						</Skeleton>
					</Card>
				</Col>
			)}
			{totalUnprocessedCountContent && (
				<Col span={4}>
					<Card
						title={totalUnprocessedCountTitle.toUpperCase()}
						bordered={false}
						style={{ width: 250 }}
					>
						<Skeleton loading={loading}>
							<Title level={3}>{totalUnprocessedCountContent}</Title>
						</Skeleton>
					</Card>
				</Col>
			)}
		</Row>
	);
};

export default CountCard;
